import { useStyles } from '@archipro-design/aria';
import { Outlet, useRouteLoaderData, useSearchParams } from 'react-router';
import { data as routerData } from 'react-router';
import type { LoaderFunctionArgs } from '~/types/route-args';

import * as S from '@modules/professional/component/page-layout/PageLayout.style';
import { loader as infoLoader } from '@modules/professional/api/info-page-loader.server';
import type { loader as layoutLoader } from '@modules/professional/page/loaders/professional-page-loader.server';
import { isProfessionalRevampActive } from '@modules/professional/util/is-professional-revamp-active.server';
import { shouldRevalidateProfessionalInfoLayout } from '~/modules/professional/util/professional-layout-revalidation';
import type { APHandle } from '~/modules/root';

export const handle: APHandle = {
    showBannerAndLogoMobile: true,
    hideContactArchiPro: true,
};

export const loader = async (args: LoaderFunctionArgs) => {
    // The revamp About page renders full-bleed at the index route, so skip the
    // heavy legacy info fetch here when the revamp is active.
    if (isProfessionalRevampActive(args.context, args.request)) {
        return routerData(null);
    }
    return infoLoader(args);
};

export const shouldRevalidate = shouldRevalidateProfessionalInfoLayout;

const ProfessionalInfoLayout = () => {
    const { css } = useStyles();
    const layoutData = useRouteLoaderData<typeof layoutLoader>(
        'routes/_app.professional.$urlSegment',
    );
    const [searchParams] = useSearchParams();
    const showRevamp =
        layoutData?.detailsRevamp ||
        (import.meta.env.DEV &&
            (searchParams.get('revamp') === '1' ||
                searchParams.get('detailsRevamp') === '1'));

    // Revamp pages are full-bleed; drop the legacy container + gutters.
    if (showRevamp) return <Outlet />;

    return (
        <div className={css(S.PageContent)}>
            <div className={css(S.Container)}>
                <Outlet />
            </div>
        </div>
    );
};

export default ProfessionalInfoLayout;
